<template>
  <v-layout row wrap class="mb-5">
    <v-flex xs12 class="mb-1">
      <div class="section-header">
        <span v-show="$vuetify.breakpoint.smAndDown">
          <v-icon class="greyIcon">
            collections
          </v-icon>
        </span>
        <span class="ml-1 label" :class="{'header-label': $vuetify.breakpoint.smAndDown}">
          Creative Details
        </span>
      </div>
      <div class="line" v-if="$vuetify.breakpoint.xsOnly" />
    </v-flex>
    <v-flex xs12 class="app-card elevation-3 rounded">
      <div class="app-card-content custom-card-content">
        <v-layout row wrap justify-center>
          <v-flex
            xs12
            ref="fbAd"
          >
            <v-layout>
              <v-flex xs10>
                <span class="ml-1 label">
                  Facebook Ad
                </span>
              </v-flex>
              <v-flex
                xs2
                class="editIconContainer"
              >
                <span id="attach" style="margin: 0 auto;">
                  <v-menu
                    fixed
                    left
                    offset-y
                    attach="#attachId"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        type="button"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon class="editIcon">
                          edit
                        </v-icon>
                        <span
                          class="label editIcon"
                          v-show="$vuetify.breakpoint.mdAndUp"
                        >
                          {{ $t('message.bizgainOnboarding.edit') }}
                        </span>
                      </button>
                    </template>
                    <v-card>
                      <v-card-text class="overflow-y-auto pa-0 ma-0">
                        <v-layout row wrap justify-center>
                          <v-flex xs12>
                            <v-flex
                              xs12
                              class="pa-4 creative-item ma-0"
                              @click="updateEditDialogType(facebookAdDetailsOptions.EDIT_CREATIVE.id)"
                            >
                              <span class="label">
                                {{ $t('message.bizgainOnboarding.creatives') }}
                              </span>
                            </v-flex>
                            <v-flex xs12 class="pa-4 creative-item ma-0" @click="updateEditDialogType(facebookAdDetailsOptions.EDIT_AD_COPY.id)">
                              <span class="label">
                                {{ $t('message.bizgainOnboarding.adcopies') }}
                              </span>
                            </v-flex>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </span>
              </v-flex>
            </v-layout>
            <v-flex v-if="facebookAdDetails && extractedCreativeDetails">
              <facebook-instagram-ad-preview
                :facebook-ad-details="facebookAdDetails"
                :extracted-creative-details="extractedCreativeDetails"
                :template="template"
                :show-facebook-preview="true"
                :show-instagram-preview="true"
              />
            </v-flex>
          </v-flex>
          <v-flex
            xs12
            v-if="!isInstantMessageObjective"
            class="mt-4"
            ref="googleAd"
          >
            <v-layout>
              <v-flex xs10>
                <span class="ml-1 label">
                  Google Ad
                </span>
              </v-flex>
              <v-flex
                xs2
                class="editIconContainer"
                @click="editGoogleAdsEdit()"
              >
                <span style="margin: 0 auto;">
                  <v-icon class="editIcon">
                    edit
                  </v-icon>
                  <span class="label editIcon" v-show="$vuetify.breakpoint.mdAndUp">
                    Edit
                  </span>
                </span>
              </v-flex>
            </v-layout>
            <v-flex v-if="isGoogleAdsPreview" class="align-self-start">
              <preview :ad-count="2" :edited-business-details="editedBusinessDetails" :is-summary="true" />
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <v-dialog
        persistent
        v-model="dialog"
        v-if="dialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '900px'}`"
      >
        <edit-creative-details-dialog
          v-if="editDialogType==facebookAdDetailsOptions.EDIT_CREATIVE.id"
          :template="template"
          :from-summary="true"
          :facebook-ad-details="facebookAdDetails"
          :extracted-creative-details="extractedCreativeDetails"
          :edited-business-details="editedBusinessDetails"
          @close-dialog="closeDialog"
          @creative-discarded="revertChanges"
          @updateBusinesssandCreativeDetails="updateBusinesssandCreativeDetails"
        />
        <edit-ad-details-dialog
          v-else-if="editDialogType==facebookAdDetailsOptions.EDIT_AD_COPY.id"
          :from-summary="true"
          @updateBusinesssandCreativeDetails="updateBusinesssandCreativeDetails"
          :template="template"
          :facebook-ad-details="facebookAdDetails"
          @updateFacebookAdDetails="updateFacebookAdDetails"
          :extracted-creative-details="extractedCreativeDetails"
          :edited-business-details="editedBusinessDetails"
          @closeDialog="dialog = false"
          @details-discarded="revertChanges"
        />
      </v-dialog>
      <v-dialog
        persistent
        v-model="googleAdsdialog"
        v-if="googleAdsdialog"
        content-class="edit-dialog"
        :max-width="`${$vuetify.breakpoint.smAndDown ? '90vw' : '900px'}`"
      >
        <edit-google-ad-fields
          :from-summary="true"
          @update="updateGoogleAdDetails"
          @closeDialog="googleAdsdialog = false"
        />
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import { bizgainOnboardingRoutes, objectiveType, facebookAdDetailsOptions, cbApiUrlForTemplates, imageTypes } from 'Features/bizgainOnboarding/constants';
import { extractCreativeDetails, generateFacebookAdDetails, getCreativeTemplate } from 'Features/bizgainOnboarding/helpers/templateHelper';
import { updateBusinessDetailsFromDbSession, getImageFileFromUrl, createImageFormDataRequest } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { uploadImage } = new ApiService();
import {
  VCard,
  VCardText,
  VFlex,
  VIcon,
  VLayout,
  VMenu,
  VDialog
} from 'vuetify/lib';
import { mapGetters, mapActions } from 'vuex';
import Preview from '../../googleAdsPreview/components/Preview.vue';
import FacebookInstagramAdPreview from '../../imageCreativesAdPreview/components/FacebookInstagramAdPreview.vue';
import EditAdDetailsDialog from '../../../../campaign/dialogs/EditAdDetails.vue';
import EditCreativeDetailsDialog  from '../../../../campaign/dialogs/EditCreativeDetails.vue';
import EditGoogleAdFields from '../dailogs/editGoogleAdFields.vue';
import { launchState } from 'Features/bizgainOnboarding/constants.js';

export default {
  components: {
    VLayout,
    VFlex,
    VIcon,
    VMenu,
    VCard,
    VCardText,
    VDialog,
    EditAdDetailsDialog,
    EditCreativeDetailsDialog,
    FacebookInstagramAdPreview,
    Preview,
    EditGoogleAdFields
  },
  async created(){
    if(this.businessDetails.launchState <= this.launchState.GOOGLEADPREVIEW){
      this.isGoogleAdsPreview = false;
    }
    this.editedBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
    if(this.id){
      this.template = this.businessDetails.creativeDetail.templates.find((x) => x.id == this.id);
      this.facebookAdDetails = generateFacebookAdDetails(this.businessDetails);
      this.extractedCreativeDetails = extractCreativeDetails(this.businessDetails);
    }
    if (this.businessDetails.hasOwnProperty('creativeDetail')){
      if (this.businessDetails.creativeDetail.objective == this.objectiveType.instantMessages.id){
        this.isInstantMessageObjective = true;
      }
    }
    if (this.sessionId){
      await updateBusinessDetailsFromDbSession(this.sessionId);
    }
    if(this.businessDetails.launchState >= this.launchState.CREATIVES){
      this.updateCreativeData();
    }
  },
  data(){
    return {
      bizgainOnboardingRoutes,
      launchState,
      extractedCreativeDetails: null,
      editedBusinessDetails: null,
      facebookAdDetails: null,
      template: null,
      textAds: [],
      isInstantMessageObjective: false,
      objectiveType,
      scrollTo: null,
      facebookAdDetailsOptions,
      dialog: false,
      editDialogType: null,
      isUpdated: false,
      imageTypes,
      googleAdsdialog: false,
      isGoogleAdsPreview: true
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'isInAppCampaign', 'businessProfileId', 'roimaticCampaignId', 'isBusinessLogoModalEnabled', 'creativeImages']),
    id() {
      return this.$route.params.id ? this.$route.params.id : this.businessDetails && this.businessDetails.creativeDetail && this.businessDetails.creativeDetail.selectedTemplateId;
    }
  },
  methods: {
    ...mapActions(['setCreativeImages', 'patchBusinessDetails', 'updateMessage', 'getBusinessDetails']),
    getTextAds() {
      let count = this.adCount;
      this.textAds = [];
      if(Array.isArray(this.services) && this.services.length === 1) {
        count = 2;
      }
      let details = this.businessDetails.creativeDetail.adDetail.textAd;
      for(let i = 0; i < count; i++) {
        let description = this.descriptionNo == 1 ?  details.description1 : details.alternativeDescription1
        let macro = description.includes(businessDetailsMacros.services) ? businessDetailsMacros.services : businessDetailsMacros.alternateServices;
        if(!this.isSingleServiceSelected || description.includes(macro)){
          description = description.replace(macro, this.services[this.serviceNo]);
        }
        this.textAds.push({ description })
        this.serviceNo = (this.serviceNo + 1) % this.services.length;
        if(this.serviceNo == 0 && this.services.length % 2 == 0) {
          this.services.unshift(this.services.pop());
        }
        this.descriptionNo = this.descriptionNo == 1 ? 2 : 1;
      }
    },
    goToImageCreativeAdDetailsEdit(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name, params: { isAppFlow: true, id: this.businessDetails.creativeDetail.selectedTemplateId, fromSummary: true, scroll: 'creative' } });
    },
    goToImageCreativesCreativeEdit(){
      this.$router.push({ name: this.bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name, params: { isAppFlow: true, id: this.businessDetails.creativeDetail.selectedTemplateId, fromSummary: true, scroll: 'creative'  } });
    },
    editGoogleAdsEdit(){
      this.googleAdsdialog = true;
    },
    updateEditDialogType(option){
      this.editedBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      this.dialog = true;
      switch (option) {
        case facebookAdDetailsOptions.EDIT_CREATIVE.id:
          this.editDialogType = facebookAdDetailsOptions.EDIT_CREATIVE.id;
          break;
        case facebookAdDetailsOptions.EDIT_AD_COPY.id:
          this.editDialogType = facebookAdDetailsOptions.EDIT_AD_COPY.id;
          break;
      }
    },
    async updateGoogleAdDetails(details) {
      try {
        if(this.businessDetails){
          this.editedBusinessDetails = details;
          this.newBusinessDetails = JSON.parse(JSON.stringify(this.editedBusinessDetails));
          let payload = {
            sessionId: this.businessDetails.sessionId,
            oldBusinessDetails: this.businessDetails,
            newBusinessDetails: this.newBusinessDetails
          };
          await this.patchBusinessDetails(payload);
        }
        this.googleAdsdialog = false;
      }
      catch {
        this.googleAdsdialog = false;
      }
    },
    updateFacebookAdDetails(){
      this.facebookAdDetails = generateFacebookAdDetails(this.editedBusinessDetails);
    },
    closeDialog(){
      this.dialog = false;
    },
    closeGoogleAdsDialog() {
      this.googleAdsdialog = false;
    },
    updateExctractedCreativeDetails(){
      this.extractedCreativeDetails = extractCreativeDetails(this.editedBusinessDetails);
    },
    revertChanges(editedBusinessDetails){
      this.editedBusinessDetails = JSON.parse(JSON.stringify(editedBusinessDetails));
      this.updateExctractedCreativeDetails();
    },
    async updateBusinesssandCreativeDetails(){
      try{
        this.isUpdated = true;
        let selectedTemplateId = this.businessDetails.creativeDetail.selectedTemplateId;
        var creativeUrl = this.creativeImages.find(creativeImage=>creativeImage.templateId == selectedTemplateId);
        var file = await getImageFileFromUrl(creativeUrl.canvasImage);

        let formData = createImageFormDataRequest(
          this.businessDetails.sessionId,
          selectedTemplateId,
          file,
          null,
          this.imageTypes.creative,
          'Creative.png'
        );
        let uploadedCreative = await uploadImage(formData);
        this.editedBusinessDetails.creativeDetail.creativeUrl = uploadedCreative.data.imageDetail.url;
        this.template = this.editedBusinessDetails.creativeDetail.templates.find((x) => x.id == this.id);
        this.updateExctractedCreativeDetails();
        let businessDetailsPayload = {
          sessionId: this.businessDetails.sessionId,
          oldBusinessDetails: this.businessDetails,
          newBusinessDetails: this.editedBusinessDetails
        };
        await this.patchBusinessDetails(businessDetailsPayload);
        await this.getBusinessDetails({ sessionId: this.businessDetails.sessionId });
        this.isUpdated = false;
      }catch (error) {
        this.updateMessage({ type: 'error', message: this.$tc('message.bizgainOnboarding.failedToSaveTemplate') });
        this.isUpdated = false;
      }
      finally{
        this.dialog = false;
      }
    },
    updateCreativeData(){
      if(this.template.leadImage && this.template.leadImage.url){
        this.creativeUrl = `${cbApiUrlForTemplates(this.template.publishedRoimaticCreativeSetId)}&${getCreativeTemplate(this.objective, this.template.type, this.template.logo, this.template.leadImage, this.extractedCreativeDetails)}`;
        this.updateCreativeImage({ templateId: this.template.id,  canvasImage: this.creativeUrl });
      }
    },
    updateCreativeImage(e){
      this.setCreativeImages(e);
    }
  }
}
</script>
<style lang="scss" scoped>
.line{
  width: 28%;
  border-bottom: solid;
  border-bottom-color: #54B4D3;
}
.creative-item {
  margin: 0px !important;
  padding: 18px !important;
  padding-right: 24px !important;
  padding-left: 24px !important;
}
.creative-item:hover{
  background-color: whitesmoke;
}
.section-header{
  display: flex;
  align-content: center;
}
.header-label{
  padding-top: 2px !important;
}
.greyIcon{
  color: #727891;
}
.editIconContainer{
  cursor: pointer;
}
.editIcon{
  color: #13abb1;
}
.custom-card-content{
  padding-bottom: 0 !important;
}
::v-deep .edit-dialog {
    max-height: 100%;
    margin: 0px;
  }
@media only screen and (max-width: 600px) {
  .editIcon{
    color: #727891;
  }
}
</style>

